export default "__VITE_ASSET__BLJSXDHP__"